// Here the response of new upload document api from cloud convert service is mapped to the old api response format
const mapDocumentResponse = function (response) {
  return {
    fileInfo: {
      doc_id: String(response.docId),
      ria_id: String(response.riaId),
      client_id: String(response.clUserId),
      bucket_name: response.bucketName,
      bucket_region: response.bucketRegion,
      folder_name: response.folderName,
      file_name: response.fileName,
      file_description: response.fileDescription,
      file_id: response.fileId,
      mime_type: response.mimeType,
      shared: String(response.shared),
      upload_date: response.uploadDate,
      removed: String(response.removed),
      uploaded_by: String(response.uploadedBy),
      advisor_upload: String(response.advisorUpload),
      page_count: String(response.pageCount),
      file_name_alt: response.fileNameAlt,
      sig_tags: String(response.sigTags),
    },
  };
};

export {mapDocumentResponse};
